/**
 * Did the user simply dismiss the Cast device chooser?
 *
 * The Cast SDK rejects `requestSession()` with `ErrorCode.CANCEL` ("cancel")
 * when the chooser is closed without picking a device — and some builds reject
 * with the bare string instead of an error object. That is a normal user
 * action, not a failure, but the player treated every rejection alike and left
 * a sticky "Cast: cancel" banner that could only be cleared with Retry.
 */
export function isCastCancel(e: unknown): boolean {
  const err = e as { description?: string; code?: string; message?: string } | null;
  const raw =
    typeof e === "string"
      ? e
      : err?.description || err?.code || err?.message || "";
  return /^\s*cancel/i.test(String(raw));
}
